<template>
  <div style="max-block-size: -webkit-fill-available; overflow-y: scroll; line-height: 20px;">
    <!-- <div v-for="(item, index) in 6" :key="index">
    {{ params.data.extraExpense  +  " - " + item +  " - " + index}}
    </div> -->
    <div class="tFlex tFlex_jc-sb">
      <b> Navlun Masrafı </b> <span>{{ params.data.freightExpense }} TL</span>
    </div>
    <div class="tFlex tFlex_jc-sb">
      <b> Vergi Tutarı </b> <span>{{ params.data.customsTariff }} TL</span>
    </div>
    <div class="tFlex tFlex_jc-sb">
      <b> Vergi Masrafları </b> <span>{{ params.data.customsExpense }} TL</span>
    </div>
    <div class="tFlex tFlex_jc-sb">
      <b> Kargo Masrafı </b> <span>{{ params.data.deliveryOrderExpense }} TL</span>
    </div>
    <div class="tFlex tFlex_jc-sb">
      <b> Depolama Masrafı </b> <span>{{ params.data.warehouseExpense }} TL</span>
    </div>
    <div class="tFlex tFlex_jc-sb">
      <b> Yurtiçi Kargo Masrafı </b> <span>{{ params.data.domesticTranportationExpense }} TL</span>
    </div>
    <div class="tFlex tFlex_jc-sb">
      <b> Ekstra Masraflar </b> <span>{{ params.data.extraExpense }} TL</span>
    </div>
  </div>
</template>

<script>
export default {
  name: "CellRendererExpenseListToString",
  data() {
    return {
      purchaseDetail: "",
      span: "",
    };
  },
  computed: {
    url() {
      return "//" + this.params.data.purchaseId;
    },
  },
  beforeMount() {
    this.purchaseDetail = this.params.value;
  },
};
</script>
<style lang="scss" scoped>
.tFlex.tFlex_jc-sb {
  span {
    margin-right: 0.5rem;
  }
}
</style>
